import React from 'react'

export function getDisplayName<Props>(
  wrappedComponent: React.ComponentType<Props>
): string {
  return wrappedComponent.displayName || wrappedComponent.name || 'Component'
}
